import styled from 'styled-components'

type Props = {
	span?: number
	place?: number
}

export const GridColumn = styled.div<Props>`
	grid-column: ${({ span, place }) => {
		if (span && place) {
			return `${place} / span ${span}`
		}
		if (span) {
			return `span ${span}`
		}
		if (place) {
			return place
		}
		return null
	}};
`
